// extracted by mini-css-extract-plugin
export var headerCell = "_13-1";
export var loadingSpinnerContainer = "_13-4";
export var rowWrapper = "_13-3";
export var standaloneTable = "_13-5";
export var table = "_13-0";
export var white = "_13-2";